import { AppLayout } from "layouts";
import { lazy, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Loadable, Page } from "components";
import { setRouting } from "toolkits/redux/routing";
import { Navigate, useRoutes } from "react-router-dom";

const NotFound = Loadable(lazy(() => import("components/NotFound")));
const Dashboard = Loadable(
  lazy(() => import("screens/SuperAdminRole/Dashboard"))
);

const PlanModel = Loadable(lazy(() => import("models/PlanModel")));
const PlanServiceModel = Loadable(
  lazy(() => import("models/PlanServiceModel"))
);
const PlanPurchaseModel = Loadable(
  lazy(() => import("models/PlanPurchaseModel"))
);

const LabModel = Loadable(lazy(() => import("models/LabModel")));
const UnitModel = Loadable(lazy(() => import("models/UnitModel")));
const UserModel = Loadable(lazy(() => import("models/UserModel")));
const CityModel = Loadable(lazy(() => import("models/CityModel")));
const StateModel = Loadable(lazy(() => import("models/StateModel")));
const OrderModel = Loadable(lazy(() => import("models/OrderModel")));
const OrderStepModel = Loadable(lazy(() => import("models/OrderStepModel")));
const LabStepModel = Loadable(lazy(() => import("models/LabStepModel")));
const ActionsModel = Loadable(lazy(() => import("models/ActionsModel")));
const OrdersStatusModel = Loadable(
  lazy(() => import("models/OrdersStatusModel"))
);
const OrderView = Loadable(
  // lazy(() => import("screens/UnitAdminRole/OrderView"))
  lazy(() => import("models/OrderModel/View"))
);
const OrderCreation = Loadable(
  lazy(() => import("screens/UnitAdminRole/OrderCreation-old"))
);
const OrderCreationNew = Loadable(
  lazy(() => import("screens/UnitAdminRole/OrderCreationNew"))
);
const LabActionCost = Loadable(
  lazy(() => import("screens/LabAdminRole/LabActionCost"))
);
// const RoleModel = Loadable(lazy(() => import('models/RoleModel')));
// const RegionModel = Loadable(lazy(() => import('models/RegionModel')));
// const UserCategoryModel = Loadable(lazy(() => import('models/UserCategoryModel')));
// const TaskModel = Loadable(lazy(() => import('models/TaskModel')));

const navConfig = [
  {
    path: "/",
    element: <Navigate to="/app" replace />,
  },
  {
    url: "/",
    path: "/",
    title: "app",
    inSidebar: true,
    element: <AppLayout />,
    children: [
      {
        url: "/app",
        path: "/app",
        title: "app",
        inSidebar: true,
        element: <Dashboard />,
      },
      {
        url: "/user",
        path: "/user",
        title: "UserModel",
        inSidebar: true,
        element: (
          <Page title="UserModel">
            <UserModel />
          </Page>
        ),
      },
      {
        url: "/plan",
        path: "/plan",
        title: "PlanModel",
        inSidebar: true,
        element: (
          <Page title="PlanModel">
            <PlanModel />
          </Page>
        ),
      },
      {
        url: "/plan-service",
        path: "/plan-service",
        title: "PlanServiceModel",
        inSidebar: true,
        element: (
          <Page title="PlanServiceModel">
            <PlanServiceModel />
          </Page>
        ),
      },
      {
        url: "/plan-purchase",
        path: "/plan-purchase",
        title: "PlanPurchaseModel",
        inSidebar: true,
        element: (
          <Page title="PlanPurchaseModel">
            <PlanPurchaseModel />
          </Page>
        ),
      },
      {
        url: "/unit",
        path: "/unit",
        title: "UnitModel",
        inSidebar: true,
        element: (
          <Page title="UnitModel">
            <UnitModel />
          </Page>
        ),
      },
      {
        url: "/lab",
        path: "/lab",
        title: "LabModel",
        inSidebar: true,
        element: (
          <Page title="LabModel">
            <LabModel />
          </Page>
        ),
      },
      {
        url: "/actions",
        path: "/actions",
        title: "ActionsModel",
        inSidebar: true,
        element: (
          <Page title="ActionsModel">
            <ActionsModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: "/order",
        path: "/order",
        title: "OrderModel",
        inSidebar: true,
        element: (
          <Page title="Orders">
            <OrderModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        // url: "/order-view",
        path: "/order/:id",
        title: "OrderView",
        inSidebar: false,
        element: (
          <Page title="OrderView">
            <OrderView />
          </Page>
        ),
      },
      {
        url: "/new-order",
        path: "/new-order",
        title: "OrderCreation",
        inSidebar: true,
        element: <OrderCreation />,
      },
      {
        url: "/order-creation-new",
        path: "/order-creation-new",
        title: "OrderCreation",
        inSidebar: true,
        element: <OrderCreationNew />,
      },
      // {
      //   url: "/action-cost",
      //   path: "/action-cost",
      //   title: "LabActionCost",
      //   inSidebar: true,
      //   element: (
      //     <Page title="LabActionCost">
      //       <LabActionCost />
      //     </Page>
      //   ),
      // },
      {
        url: "/states",
        path: "/states",
        title: "StateModel",
        inSidebar: true,
        element: <StateModel />,
      },
      {
        url: "/cities",
        path: "/cities",
        title: "CityModel",
        inSidebar: true,
        element: <CityModel />,
      },
      {
        url: "/orders-status",
        path: "/orders-status",
        title: "OrdersStatusModel",
        inSidebar: false,
        element: (
          <Page title="OrdersStatusModel">
            <OrdersStatusModel />
          </Page>
        ),
      },
      {
        url: "/orders-step",
        path: "/orders-step",
        title: "OrderStepModel",
        inSidebar: true,
        element: (
          <Page title="OrderStepModel">
            <OrderStepModel />
          </Page>
        ),
      },
      {
        url: "/lab-step",
        path: "/lab-step",
        title: "LabStepModel",
        inSidebar: true,
        element: (
          <Page title="LabStepModel">
            <LabStepModel />
          </Page>
        ),
      },
    ],
  },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "sign-in",
        element: <Navigate to="/" replace />,
      },
      {
        path: "sign-up",
        element: <Navigate to="/" replace />,
      },
      {
        path: "reset-password",
        element: <Navigate to="/" replace />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/404" replace />,
  },
];

function cleanRoutes({ url, title, inSidebar, children }) {
  if (inSidebar) {
    if (children && children.length > 0) {
      children = children.map((c) => cleanRoutes(c));
      return { url, title, inSidebar, children };
    }
    return { url, title, inSidebar, children: [] };
  }
  return {};
}

export default function Router() {
  const dispatch = useDispatch();
  useEffect(() => {
    // console.log(navConfig.map((x) => cleanRoutes(x)).filter((x) => x));
    dispatch(setRouting(navConfig.map((x) => cleanRoutes(x)).filter((x) => x)));
  }, []);
  return useRoutes(navConfig);
}
